// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useQuery } from '../../lib/utility';
import { Chapter, Module, ModuleType, Subtitles } from '../../types/Model';
import { CourseType } from './CourseContent';
import axios, { CancelTokenSource } from 'axios';
import MemberContext from '../../contexts/MemberContext';
import { actionCreatorsList } from '../../redux/rootActionCreator';
import { useDispatch } from 'react-redux';

export function useSendActive(): (duration: number, sourceFrom: string, sourceId: number, vodId: number) => void {
  const member = useContext(MemberContext);
  const dispatch = useDispatch();

  return useCallback((duration: number, sourceFrom: string, sourceId: number, vodId: number) => {
    dispatch(actionCreatorsList.sendActiveActions.request({ duration, organizationId: member.organizationId || null, sourceFrom, sourceId, vodId }))
  }, [member])
}

/**
 * Get chapter and module id (start from 1) from url querystring
 * @returns [chapterId, moduleId]
 */
export function useChapterModuleId(): [number, number] {
  const query = useQuery();

  return useMemo(() => {
    const chapterId = parseInt(query.get('chapter') || '1', 10)
    const moduleId = parseInt(query.get('module') || '1', 10)

    return [chapterId, moduleId];
  }, [query]);
}

export function useCurrentModule(chapters: Chapter[]): Module | undefined {
  const [chapterId, moduleId] = useChapterModuleId();

  return useMemo(() => {
    if (!chapters[chapterId - 1] || !chapters[chapterId - 1].modules[moduleId - 1]) {
      return undefined;
    }

    return chapters[chapterId - 1].modules[moduleId - 1];
  }, [chapters, chapterId, moduleId]);
}

export function useVodId(currentModule?: Module): number {
  return useMemo(() => {
    if (currentModule && 'vodId' in currentModule) {
      return currentModule.vodId;
    }

    return 0;
  }, [currentModule])
}

export function useLabId(currentModule?: Module): number {
  return useMemo(() => {
    if (currentModule && 'labId' in currentModule) {
      return currentModule.labId;
    }

    return 0;
  }, [currentModule])
}

export function useChallengeId(currentModule?: Module): number {
  return useMemo(() => {
    if (currentModule && 'challengeId' in currentModule) {
      return currentModule.challengeId;
    }

    return 0;
  }, [currentModule])
}

export function useExamId(currentModule?: Module): number {
  return useMemo(() => {
    if (currentModule && 'examId' in currentModule) {
      return currentModule.examId;
    }

    return 0;
  }, [currentModule])
}

export function useHyperlinkId(currentModule?: Module): string | undefined {
  return useMemo(() => {
    if (currentModule && 'hyperlinkId' in currentModule) {
      return currentModule.hyperlinkId;
    }

    return 'null';
  }, [currentModule])
}

export function useAssessmentId(currentModule?: Module): number {
  return useMemo(() => {
    if (currentModule && 'assessmentId' in currentModule) {
      return currentModule.assessmentId;
    }

    return 0;
  }, [currentModule])
}

export function useCourseType(): CourseType {
  const location = useLocation();

  return useMemo(() => {
    return location.pathname.split('/')[1] as CourseType
  }, [location])
}

export function useCurrentSubtitle(currentModule?: Module): Subtitles {
  const [subtitles, setSubtitles] = useState<Subtitles>({});

  useEffect(() => {
    setSubtitles({});
    const sources: CancelTokenSource[] = [];

    if (currentModule && currentModule.type === ModuleType.VIDEO) {
      const subtitleUrls = currentModule.subtitles;

      for (const key in subtitleUrls) {
        const source = axios.CancelToken.source();
        sources.push(source);

        axios.get(subtitleUrls[key], {
          cancelToken: source.token
        })
          .then(({ data }) => {
            setSubtitles(subtitles => ({
              ...subtitles,
              ...{ [key]: data }
            }))
          })
          .catch((err) => {
            console.log({ err })
          });
      }
    }

    return () => {
      for (const cancel of sources) {
        cancel.cancel('Abort because source changed');
      }
    }
  }, [currentModule]);

  return subtitles;
}
